/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestnotfounderror3Inputs */

const en_requestnotfounderror3 = /** @type {(inputs: Requestnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This request no longer exists.`)
};

const de_requestnotfounderror3 = /** @type {(inputs: Requestnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Anfrage gibt es nicht mehr.`)
};

/**
* | output |
* | --- |
* | "This request no longer exists." |
*
* @param {Requestnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestnotfounderror3 = /** @type {((inputs?: Requestnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestnotfounderror3(inputs)
	return de_requestnotfounderror3(inputs)
});
export { requestnotfounderror3 as "requestNotFoundError" }